// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
/**
 * this enum is for all the search boxes that we have throughout Weave
 */
export var UiSource;
(function (UiSource) {
    UiSource["CALL_QUEUE_SEARCH"] = "CALL_QUEUE_SEARCH";
    UiSource["CONTACT_SEARCH"] = "CONTACT_SEARCH";
    UiSource["FAX_CONTACT_SEARCH"] = "FAX_CONTACT_SEARCH";
    UiSource["FAX_INBOX_SEARCH"] = "FAX_INBOX_SEARCH";
    UiSource["GLOBAL_SEARCH"] = "GLOBAL_SEARCH";
    UiSource["INVOICE_HISTORY_SEARCH"] = "INVOICE_HISTORY_SEARCH";
    UiSource["LOCATION_SEARCH"] = "LOCATION_SEARCH";
    UiSource["MY_FORMS_SEARCH"] = "MY_FORMS_SEARCH";
    UiSource["ORG_SEARCH"] = "ORG_SEARCH";
    UiSource["RECENT_CALLS_SEARCH"] = "RECENT_CALLS_SEARCH";
    UiSource["REVIEW_SEARCH"] = "REVIEW_SEARCH";
    UiSource["SETTINGS_SEARCH"] = "SETTINGS_SEARCH";
    UiSource["SUBMISSION_SEARCH"] = "SUBMISSION_SEARCH";
    UiSource["VOICEMAIL_SEARCH"] = "VOICEMAIL_SEARCH";
})(UiSource || (UiSource = {}));
export var UiSource_index;
(function (UiSource_index) {
    UiSource_index[UiSource_index["CALL_QUEUE_SEARCH"] = 0] = "CALL_QUEUE_SEARCH";
    UiSource_index[UiSource_index["CONTACT_SEARCH"] = 1] = "CONTACT_SEARCH";
    UiSource_index[UiSource_index["FAX_CONTACT_SEARCH"] = 2] = "FAX_CONTACT_SEARCH";
    UiSource_index[UiSource_index["FAX_INBOX_SEARCH"] = 3] = "FAX_INBOX_SEARCH";
    UiSource_index[UiSource_index["GLOBAL_SEARCH"] = 4] = "GLOBAL_SEARCH";
    UiSource_index[UiSource_index["INVOICE_HISTORY_SEARCH"] = 5] = "INVOICE_HISTORY_SEARCH";
    UiSource_index[UiSource_index["LOCATION_SEARCH"] = 12] = "LOCATION_SEARCH";
    UiSource_index[UiSource_index["MY_FORMS_SEARCH"] = 6] = "MY_FORMS_SEARCH";
    UiSource_index[UiSource_index["ORG_SEARCH"] = 11] = "ORG_SEARCH";
    UiSource_index[UiSource_index["RECENT_CALLS_SEARCH"] = 10] = "RECENT_CALLS_SEARCH";
    UiSource_index[UiSource_index["REVIEW_SEARCH"] = 7] = "REVIEW_SEARCH";
    UiSource_index[UiSource_index["SETTINGS_SEARCH"] = 13] = "SETTINGS_SEARCH";
    UiSource_index[UiSource_index["SUBMISSION_SEARCH"] = 8] = "SUBMISSION_SEARCH";
    UiSource_index[UiSource_index["VOICEMAIL_SEARCH"] = 9] = "VOICEMAIL_SEARCH";
})(UiSource_index || (UiSource_index = {}));
